/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@package/api-client/client-config";
import type { ListOrganizationsQueryResponse } from "../../types/organizationController/ListOrganizations.ts";
import type { RequestConfig, ResponseErrorConfig } from "@package/api-client/client-config";

function getListOrganizationsUrl() {
  const res = { method: 'GET', url: `/api/organizations/` as const }  
  return res
}

/**
 * @summary List organizations for current user
 * {@link /api/organizations/}
 */
export async function listOrganizations(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ListOrganizationsQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getListOrganizationsUrl().url.toString(), ... requestConfig })  
  return res.data
}